import common from './common.json' with { type: 'json' };
import auth from './auth.json' with { type: 'json' };
import errors from './errors.json' with { type: 'json' };
import datatable from './datatable.json' with { type: 'json' };
import styleguide from './styleguide.json' with { type: 'json' };
import notifications from './notifications.json' with { type: 'json' };
import moderation from './moderation.json' with { type: 'json' };
import admin from './admin.json' with { type: 'json' };
import pwa from './pwa.json' with { type: 'json' };
import emails from './emails.json' with { type: 'json' };
import push from './push.json' with { type: 'json' };
/**
 * Typed against `Catalog` (derived from `en`) so a missing key in any scope
 * is a compile-time structural error. This is a first line of defense; the
 * runtime keyset-parity test (`catalogs.test.ts`) is the exhaustive check
 * (catches a *renamed* key, which structural typing alone can miss when the
 * mismatch happens deep inside an already-typed nested object).
 */
export const roCatalog = {
    common,
    auth,
    errors,
    datatable,
    styleguide,
    notifications,
    moderation,
    admin,
    pwa,
    emails,
    push,
};
